import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Divider, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { JsonViewer } from './jsonViewer'; 

function ViewLogDialogBox({ open, setOpen, sequenceLogData }) {
  const handleClose = () => {
    setOpen(false);
  };

  const apiRequest = sequenceLogData?.data?.[0]?.apiRequest ?? null;
  const apiResponse = sequenceLogData?.data?.[0]?.apiResponse ?? null;

  const parseJsonSafely = (data) => {
    if (data === null) {
      return null;
    }
    try {
      return JSON.parse(data);
    } catch (error) {
      console.error('Error parsing JSON:', error);
      return data;
    }
  };

  const requestJson = parseJsonSafely(apiRequest);
  const responseJson = parseJsonSafely(apiResponse);

  return (
    <Dialog
  open={open}
  onClose={handleClose}
 
  sx={{
    "& .MuiPaper-root": {
      borderRadius: "12px",
      boxShadow: "0px 6px 20px rgba(0,0,0,0.25)",
    },
  }}
>
  <Box sx={{ maxWidth: "60rem", minWidth: { xs: "25rem", sm: "48rem" } }}>
    {/* Header */}
    <Box
      sx={{
        userSelect: "none",
        position: "sticky",
        top: 0,
        background: "#fff",
        zIndex: 10,
      }}
    >
      <Typography
        variant="h5"
        sx={{ padding: "12px 16px", fontWeight: 600 }}
      >
        API Details
      </Typography>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{ position: "absolute", top: "12px", right: "12px" }}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
    </Box>

    {/* Content */}
    <Box sx={{ padding: "20px" }}>
      {/* Request */}
      <Typography variant="h6" fontWeight={600}>
        Request
      </Typography>
      <Box
        sx={{
          background: "#f9f9f9",
          color: "#1a1a1a",
          marginTop: "8px",
          padding: "12px",
          borderRadius: "8px",
          fontSize: "14px",
          fontFamily: "monospace",
          border: "1px solid #e0e0e0",
        }}
      >
        {requestJson !== null ? (
          <JsonViewer value={requestJson} />
        ) : (
          <Typography color="textSecondary">null</Typography>
        )}
      </Box>

      {/* Response */}
      <Typography mt={4} variant="h6" fontWeight={600}>
        Response
      </Typography>
      <Box
        sx={{
          background: "#f9f9f9",
          color: "#1a1a1a",
          marginTop: "8px",
          padding: "12px",
          borderRadius: "8px",
          fontSize: "14px",
          fontFamily: "monospace",
          border: "1px solid #e0e0e0",
          maxHeight: "350px",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#b0b0b0",
            borderRadius: "4px",
          },
        }}
      >
        {responseJson !== null ? (
          <JsonViewer value={responseJson} />
        ) : (
          <Typography color="textSecondary">null</Typography>
        )}
      </Box>
    </Box>
  </Box>
</Dialog>

  );
}

export default ViewLogDialogBox;
